module.exports = __webpack_public_path__ + "static/media/backgroundAvionN4.cc84be78.png";